import React, { FC } from 'react';
import { ComparisonCompaniesTable } from 'dashboard409a/components';
import { ComparisonCompaniesProps } from './types';

const ComparisonCompanies: FC<ComparisonCompaniesProps> = props => <ComparisonCompaniesTable {...props} />;

export default ComparisonCompanies;
